import React from 'react';
import RoutingSettingsPage from './RoutingSettingsPage';

// The shared routing form in edit mode (VCC or Direct Bill, from the rule) — see RoutingSettingsPage.
const EditRoutingPage = () => <RoutingSettingsPage mode="edit" />;

export default EditRoutingPage;
